
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { handleError, initClient } from '../../../api';
import { fixISettings } from '../../../util';
import { AccountApiClient, AccountSelect, TreeNode, UserUiClient } from '../../backend/backendapi';

@Component
export default class HqAccountEditor extends Vue {
  @Prop({ required: true })
  readonly userId!: string;

  private readonly accountApi = initClient(AccountApiClient);
  private readonly userApi = initClient(UserUiClient);

  accountSelect: AccountSelect | null = null;
  hqAccountId: number | null = null;

  get unsetHqAccount() {
    return new TreeNode({ dbId: 0, path: '', text: '(' + this.$t('general.none').toString() + ')' });
  }

  get hqAccountInsideAccountSelect(): boolean {
    if (!this.accountSelect || this.hqAccountId === null) {
      return false;
    }
    if (this.hqAccountId === 0) {
      return true;
    }
    return !!this.accountSelect.parentList?.find(e => e.dbId === this.hqAccountId!);
  }

  get options(): TreeNode[] {
    return [this.unsetHqAccount, ...(this.accountSelect?.parentList ?? [])];
  }

  created(): void {
    fixISettings();
  }

  async reload(): Promise<void> {
    //reset first
    this.accountSelect = null;
    this.hqAccountId = null;

    //load
    this.hqAccountId = (await this.userApi.getHqAccount(this.userId))?.dbId ?? this.unsetHqAccount.dbId!;
    this.accountSelect = await this.accountApi.getAccountSelect(undefined);
  }

  async save(): Promise<void> {
    if (this.hqAccountId === null) {
      return;
    }

    try {
      await this.userApi.setHqAccount(this.userId, this.hqAccountId);
    } catch (e) {
      handleError(this.$toasted, this.$i18n, e);
      throw new Error();
    }
  }

  @Watch('userId', { immediate: true }) //immediate: trigger on first value set too
  private onUserIdChanged(): void {
    this.reload();
  }
}
